<template>
  <div class="a-dialog">
    <el-dialog
      v-if="value"
      :title="title"
      top="10vh"
      :visible.sync="dialogVisible"
      :show-close="showClose || true"
      :center="center || false"
      :close-on-click-modal="closeModal || false"
      :close-on-press-escape="closeEscape || true"
      :before-close="closeBefore"
      :width="setWidth"
      append-to-body
      @closed="handleDialogClose"
    >
      <div class="dialog-content">
        <slot />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-for="(btn, index) of toolbar || []"
          v-show="!btn.hide"
          :key="index"
          :disabled="btn.disabled"
          :loading="btn.loading"
          :type="btn.type || 'primary'"
          size="small"
          @click="handleClick(btn)"
        >
          {{ btn.text }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'Adialog',
  props: {
    toolbar: Array,
    closeEscape: Boolean,
    closeModal: Boolean,
    center: {
      type: Boolean,
      default: false
    },
    showClose: Boolean,
    dialogWidth: {
      type: String,
      default: '50%'
    },
    size: String,
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    },
    contentHeight: {
      type: String,
      default: '450px'
    }
  },
  data() {
    return {
      dialogVisible: this.value,
      width: {
        '1': '370px',
        '2': '680px',
        '3': '1000px',
        '4': '1320px'
      }
    }
  },
  computed: {
    setWidth() {
      return this.size ? this.width[this.size] : this.dialogWidth
    }
  },
  watch: {
    value(val) {
      this.dialogVisible = val
    }
  },
  methods: {
    handleClick(btn) {
      const { func } = btn
      func && func(this.done)
    },
    done() {
      this.resetThrottledBtn()
      this.handleDialogClose()
    },
    /** 重置节流按钮 */
    resetThrottledBtn() {
      if (this.toolbar && Array.isArray(this.toolbar)) {
        this.toolbar.map(btn => {
          if (btn.loading) {
            btn.loading = false
          }
        })
      }
    },
    closeBefore(done) {
      done()
      this.$emit('input', false)
    },
    handleDialogClose() {
      this.$emit('input', false)
      this.$emit('closeDiag')
    }
  }
}
</script>

<style lang="scss">
.el-dialog {
  .el-dialog__header {
    padding-top: 10px;
    border-bottom: 1px solid #e4e7ed;
  }
  .el-dialog__body {
    padding: 10px 20px;
    padding-bottom: 10px !important;
  }
  // .el-dialog__footer {
  //   border-top: 1px solid #e4e7ed;
  //   padding-bottom: 10px;
  // }
}
.dialog-footer{
  text-align: center;
}
</style>
